/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable import/no-cycle, no-useless-catch */
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { authUseCase, userUseCase } from '@/usecase'
import apiUseCase from '@/usecase/apiUseCase'
import { iPayloadGetToken, iPayloadLogin } from '@/utils/interfaces/iLogin'
import { IPayloadOtp } from '@/utils/interfaces/iUserResponse'
import moment from 'moment'
import { ActionTree } from 'vuex'
import { boolean } from 'yup'
import environment from '@/configs/environtment'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import { IRootState } from './model'

const actions: ActionTree<IRootState, IRootState> = {
  setToggleMenu: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_MENU', toggle)
  },
  initResize: ({ commit }) => {
    window.addEventListener('resize', () => {
      commit('SET_WIDTH', window.innerWidth)
      commit('SET_HEIGHT', window.innerHeight)
    })
  },
  initNetworkOn: ({ commit }) => {
    window.addEventListener('online', () => {
      commit('SET_CONNECTION', true)
    })
  },
  initNetworkOff: ({ commit }) => {
    window.addEventListener('offline', () => {
      commit('SET_CONNECTION', false)
      commit('SET_NO_INTERNET_MODAL', true)
    })
  },
  setWidth: ({ commit }) => {
    commit('SET_WIDTH', window.innerWidth)
  },
  setHeight: ({ commit }) => {
    commit('SET_HEIGHT', window.innerHeight)
  },
  destroyResize: ({ commit }) => {
    window.removeEventListener('resize', () => ({}))
  },
  setNoInternet: ({ commit }, noInternet: boolean) => {
    commit('SET_NO_INTERNET_MODAL', noInternet)

    if (noInternet) {
      commit('SET_SHOW_LOADING', false)
    }
  },
  showLoading: ({ commit }) => {
    commit('SET_SHOW_LOADING', true)
  },
  hideLoading: ({ commit }) => {
    commit('SET_SHOW_LOADING', false)
  },
  setToggleMenuSidebar: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_SIDEBAR', toggle)
  },
  // Components Data Table
  setShowModal: ({ commit }, showModal: boolean) => {
    commit('SET_SHOW_MODAL', showModal)
  },
  storeRowDataTable: ({ commit }, data: any) => {
    commit('STORE_ROW_DATA_TABLE', data)
  },
  flushRowDataTable: ({ commit }) => {
    commit('FLUSH_ROW_DATA_TABLE', null)
  },
  setTitleFormSidebar: ({ commit }, title: string) => {
    commit('SET_TITLE_FORM_SIDEBAR', title)
  },
  setReloadDataTable: ({ commit }) => {
    commit('SET_RELOAD_DATA_TABLE', true)
  },
  // Components Data List (DL: Data List)
  setShowModalFormDl: ({ commit }, show: boolean) => {
    commit('SET_SHOW_MODAL_FORM_DL', show)
  },
  storeRowDataListDl: ({ commit }, rowData: any) => {
    commit('STORE_ROW_DATA_LIST_DL', rowData)
  },
  setTitleFormSidebarDl: ({ commit }, title: string) => {
    commit('SET_TITLE_FORM_SIDEBAR_DL', title)
  },
  setShowModalConfirmationDl: ({ commit }, show: boolean) => {
    commit('SET_SHOW_MODAL_CONFIRMATION_DL', show)
  },
  setContentModalConfirmationDl: ({ commit }, data: any) => {
    commit('SET_CONTENT_MODAL_CONFIRMATION_DL', data)
  },
  setReloadDataList: ({ commit }) => {
    commit('SET_RELOAD_DATA_LIST', true)
  },
  flushRowDataList: ({ commit }) => {
    commit('STORE_ROW_DATA_LIST_DL', null)
  },
  // this action works to setting process all login process
  loginProcess: async ({ commit }, data: iPayloadLogin) => {
    try {
      // const response = await authUseCase.sendingLoginChallenge(data.login_challenge, data.username, data.password)
      const response = await authUseCase.loginAttempt(data.username, data.password)
      if (!response.error) {
        const date = moment()
        localStorage.setItem('ut', response.result.access_token)
        localStorage.setItem('tt', response.result.token_type)
        localStorage.setItem('it', response.result.Id)
        localStorage.setItem('ei', date.toString())
        return response
      } throw response
    } catch (error) {
      throw error
    }
  },
  // this action works to get token
  // processGetToken: async ({ commit, dispatch }, data: iPayloadGetToken) => {
  //   try {
  //     const payload = new URLSearchParams()
  //     payload.append('code', data.code)
  //     payload.append('client_id', data.client_id)
  //     payload.append('client_secret', data.client_secret)
  //     payload.append('redirect_uri', data.redirect_uri)
  //     payload.append('grant_type', data.grant_type)
  //     const response = await authUseCase.sendingAuth(payload)
  //     if (!response.error) {
  //       const date = moment()
  //       // const date = new Date()
  //       // date.setTime(date.getTime() + response.result.expires_in)
  //       localStorage.setItem('ut', response.result.access_token)
  //       localStorage.setItem('it', response.result.id_token)
  //       localStorage.setItem('ei', date.toString())
  //       await dispatch('fetchUserInfo', response.result.access_token)
  //       return response
  //     } throw response
  //   } catch (error) {
  //     throw error
  //   }
  // },
  // Logout process
  logoutAccount: async ({ commit }) => {
    localStorage.clear()
    commit('SET_USER_PROFILE', null)
  },

  fetchProfileOld: async ({ commit }) => {
    try {
      // const userInfo = JSON.parse(encryptDecriptMethods.decrypt(localStorage.getItem('userInfo')))
      const guid: string | null = localStorage.getItem('it')
      const { error, result } = await authUseCase.getProfile(guid)
      if (!error) {
        const userInfo = encryptDecriptMethods.encrypt(JSON.stringify(result))
        localStorage.setItem('userInfo', userInfo)
        localStorage.setItem('rn', result?.RolesName)
        commit('SET_USER_PROFILE', result)
      }
    } catch (error) {
      throw error
    }
  },

  fetchProfile: async ({ commit }) => {
    const base64UrlDecode = (input: string) => {
      const base64 = input.replace(/-/g, '+').replace(/_/g, '/')
      const padLength = (4 - (base64.length % 4)) % 4
      const padded = base64 + '='.repeat(padLength)
      return Buffer.from(padded, 'base64').toString('utf-8')
    }
    try {
      // const idToken: any = localStorage.getItem('it')
      // console.log('idToken', idToken)
      // const parts = idToken.split('.')
      // if (parts.length !== 3) {
      //   throw new Error('Invalid JWT format')
      // }
      // const payload = base64UrlDecode(parts[1])
      // console.log('user', JSON.parse(payload))
      // const result = JSON.parse(payload)

      const idTokenX: any = localStorage.getItem('ut')
      // console.log('idToken', idTokenX)
      const partsX = idTokenX.split('.')
      if (partsX.length !== 3) {
        throw new Error('Invalid JWT format')
      }
      // console.log('partsX', partsX)

      const payloadX = base64UrlDecode(partsX[1])
      // console.log('userX', JSON.parse(payloadX))
      const resultX = JSON.parse(payloadX)

      localStorage.setItem('userInfo', payloadX)
      localStorage.setItem('rn', resultX?.family_name)
      localStorage.setItem('ud', encryptDecriptMethods.encrypt(resultX?.sub))
      // console.log('localStorageRn', localStorage.getItem('rn'))
      commit('SET_USER_PROFILE', resultX)
    } catch (error) {
      throw error
    }
  },

  refreshToken: async ({ commit }) => {
    const tokenUrl = `${environment.getSsoBaseUrl()}/realms/${environment.getSsoRealms()}/protocol/openid-connect/token`

    const refreshTokenCode = localStorage.getItem('rt')
    const params = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: environment.getSsoClientId(),
      refresh_token: `${refreshTokenCode}`,
    })

    const response = await fetch(tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    })
    // console.log('response', response)
    if (!response.ok) {
      throw new Error('Token exchange failed')
    }
    const result: any = await response.json()

    localStorage.setItem('ut', result.access_token)
    localStorage.setItem('rt', result.refresh_token)
    localStorage.setItem('tt', result.token_type)
    localStorage.setItem('it', result.id_token)
    localStorage.setItem('ei', result.expires_in)
    // window.location.reload()
    return result.access_token
  },

  setSelectedPassenger: async ({ commit }, data: any) => {
    commit('SET_SELECTED_PASSENGER', data)
  },
  setSelectedPriceChange: async ({ commit }, data: any) => {
    commit('SET_SELECTED_PRICE_CHANGE', data)
  },
  fetchGlobalSettingHjex: async ({ commit }) => {
    try {
      const { error, result } = await userUseCase.getGlobalSettingHjex()
      if (!error) {
        commit('SET_GLOBAL_SETTING_HJEX', result)
      }
    } catch (error) {
      throw error
    }
  },

  getTokenOtp: async ({ commit }) => {
    try {
      const response = await userUseCase.loginClientCredentialsHjex()
      if (response.status === 200) {
        return response
      }
      throw response
    } catch (error) {
      return error
      throw error
    }
  },

  requestOtp: async ({ commit }, data: any) => {
    try {
      const response = await userUseCase.requestOtp(data)
      if (response.status === 200) {
        return response
      }
      throw response
    } catch (error) {
      return error
      throw error
    }
  },

  validateOtp: async ({ commit }, data: IPayloadOtp) => {
    console.log('data', data)
    try {
      const response = await userUseCase.validateOtp(data)
      if (response.status === 200 || response.status === 204 || response.status === 400) {
        return response
      }
      console.log('resValidate', response)
      throw response
    } catch (error) {
      throw error
    }
  },

  sendWhatsapp: async ({ commit }, data: IPayloadOtp) => {
    try {
      const response = await userUseCase.sendWhatsapp(data)
      if (response.status === 200) {
        return response
      }
      throw response
    } catch (error) {
      throw error
    }
  },

  setToogleChangePasswordDialog: async ({ commit }, data: any) => {
    commit('SET_TOGGLE_CHANGE_PASSWORD_DIALOG', data)
  },

  setReloadRit1Dashboard: async ({ commit }) => {
    commit('SET_RELOAD_RIT_1_DASHBOARD', true)
  },
  setReloadRit2Dashboard: async ({ commit }) => {
    commit('SET_RELOAD_RIT_2_DASHBOARD', true)
  },
  setReloadTrayek: async ({ commit }: any) => {
    commit('SET_RELOAD_TRAYEK', true)
  },
  setToggleMinimizeMenu: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_MINIMIZE_MENU', toggle)
  },
  setToggleDatatableSidebarDeleteButton: ({ commit }, toggle: boolean) => {
    commit('SET_TOGGLE_DATATABLE_SIDEBAR_DELETE_BUTTON', toggle)
  },
  setSearchField: ({ commit }, toggle: boolean) => {
    commit('SET_SEARCH_FIELD', toggle)
  },
  setTrayekHeadSearchFilter: async ({ commit }, data: any) => {
    commit('SET_TRAYEK_HEAD_SEARCH_FILTER', data)
  },
  setTrayekHeadClassFilter: async ({ commit }, data: any) => {
    console.log('data', data)
    commit('SET_TRAYEK_HEAD_CLASS_FILTER', data)
  },
  setTrayekHeadIsTolFilter: async ({ commit }, data: any) => {
    commit('SET_TRAYEK_HEAD_ISTOL_FILTER', data)
  },
  flushTrayekHeadFilter: async ({ commit }) => {
    commit('FLUSH_TRAYEK_HEAD_FILTER', null)
  },
  setTrayekForm1: async ({ commit }, data: any) => {
    console.log('data', data)
    commit('SET_TRAYEK_FORM1', data)
  },
  flushTrayekForm1: async ({ commit }) => {
    commit('FLUSH_TRAYEK_FORM1')
  },
  setTrayekForm2: async ({ commit }, data: any) => {
    commit('SET_TRAYEK_FORM2', data)
  },
  setTrayekFormStep: async ({ commit }, data: any) => {
    commit('SET_TRAYEK_FORM_STEP', data)
  },
  setTrayekPath: async ({ commit }, data: any) => {
    commit('SET_TRAYEK_PATH', data)
  },
  setHeaderButton: async ({ commit }, data: any) => {
    commit('SET_HEADER_BUTTON', data)
  },
  setHeaderButtonActionShowDialogForm: async ({ commit }, data: any) => {
    commit('SET_HEADER_BUTTON_ACTION_SHOW_DIALOG_FORM', data)
  },
  flushHeaderButton: async ({ commit }) => {
    commit('FLUSH_HEADER_BUTTON')
  },
  setListBusTrayek: async ({ commit }, data: any) => {
    commit('SET_LISTBUS_TRAYEK', data)
  },
  setVehicleMutationFormStep: async ({ commit }: any, data: any) => {
    console.log('data', data)
    commit('SET_VEHICLE_MUTATION_FORM_STEP', data)
  },
  setFirstVehicleMutation: async ({ commit }: any, data: any) => {
    commit('SET_FIRST_VEHICLE_MUTATION', data)
  },
  setSecondVehicleMutation: async ({ commit }: any, data: any) => {
    commit('SET_SECOND_VEHICLE_MUTATION', data)
  },
  setDescriptionVehicleMutation: async ({ commit }: any, data: any) => {
    commit('SET_DESCRIPTION_VEHICLE_MUTATION', data)
  },
  flushVehicleMutationForm: async ({ commit }: any) => {
    commit('FLUSH_VEHICLE_MUTATION_FORM')
  },
  setShowDialog: ({ commit }: any, showModal: boolean) => {
    commit('SET_SHOW_DIALOG', showModal)
  },
  setTabPosition: ({ commit }: any, value: number) => {
    commit('SET_TAB_POSITION', value)
  }
}

export default actions
